export default "__VITE_ASSET__ChYyW1Tx__"